module.exports = __webpack_public_path__ + "img/passo-3.437cba2e.png";